import Phaser from "phaser";

import { COLORS } from "./theme.ts";

/**
 * Horizontal countdown driven by a server timestamp, so every client shows the
 * same remaining time regardless of when its own state patch arrived.
 */
export class TimerBar extends Phaser.GameObjects.Container {
  private readonly _track: Phaser.GameObjects.Rectangle;
  private readonly _fill: Phaser.GameObjects.Rectangle;
  private _endsAt = 0;
  private _durationMs = 1;
  private _barWidth: number;

  constructor(scene: Phaser.Scene, x: number, y: number, width: number, height = 8) {
    super(scene, x, y);
    this._barWidth = width;
    this._track = scene.add.rectangle(0, 0, width, height, COLORS.surfaceRaised).setOrigin(0, 0.5);
    this._fill = scene.add.rectangle(0, 0, width, height, COLORS.accent).setOrigin(0, 0.5);
    this.add([this._track, this._fill]);
    scene.add.existing(this);
  }

  /** Call whenever the phase changes. `endsAt` is epoch millis from the server. */
  setDeadline(endsAt: number, durationMs: number): void {
    this._endsAt = endsAt;
    this._durationMs = Math.max(1, durationMs);
    this.setVisible(endsAt > 0);
  }

  resize(width: number): void {
    this._barWidth = width;
    this._track.width = width;
  }

  /** Scenes call this from their update loop. */
  tick(now: number): void {
    if (this._endsAt <= 0) return;
    const remaining = Phaser.Math.Clamp((this._endsAt - now) / this._durationMs, 0, 1);
    this._fill.width = this._barWidth * remaining;
    this._fill.fillColor = remaining < 0.25 ? COLORS.danger : COLORS.accent;
  }
}
